var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy, OnInit, ElementRef } from '@angular/core';
import { environment } from '@environments/environment';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import { takeWhile } from 'rxjs/operators';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
var moment = extendMoment(Moment);
var sinceDays = 360;
var INDRADatepickerModalComponent = /** @class */ (function (_super) {
    __extends(INDRADatepickerModalComponent, _super);
    function INDRADatepickerModalComponent(modalService, store, dateSerivce, ibeAdminService) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.store = store;
        _this.dateSerivce = dateSerivce;
        _this.ibeAdminService = ibeAdminService;
        _this.scrollLeft = 0;
        _this.isAlive = true;
        _this.bookAwardFlights$ = _this.store.select(fromStore.getFlightsFilterBookAwardFlights);
        // Initialize selector state to false
        _this.datepickerSelector = {
            open: false
        };
        // https://www.npmjs.com/package/angular4-datepicker
        _this.datepickerOptions = {
            showClearDateBtn: false,
            disableUntil: { year: moment().year(), month: moment().month() + 1, day: parseFloat(moment().format('D')) },
            disableSince: { year: parseFloat(moment().add(sinceDays, 'days').format('YYYY')), month: parseFloat(moment().add(sinceDays, 'days').format('M')), day: parseFloat(moment().add(sinceDays, 'days').format('D')) },
            markCurrentDay: true,
            yearSelector: false,
            monthSelector: false,
            showSelectorArrow: false,
            openSelectorOnInputClick: true,
            allowSelectionOnlyInCurrentMonth: false,
            inline: true,
            satHighlight: false,
            sunHighlight: false,
            showTodayBtn: false,
            ariaLabelInputField: 'Flight\'s new date',
            dayLabels: _this.INDRA_getDays(),
            allowDeselectDate: false,
            ariaLabelDay: 'Select day '
        };
        _this.range = moment.range(moment().endOf('month'), moment().add(sinceDays, 'days').endOf('month'));
        _this.defMonth = moment().format('MM') + "-" + moment().format('YYYY');
        _this.optionsMonth = Array.from(_this.range.by('month')).map(function (cur) { return ({ value: cur.format('MM-YYYY'), label: _this.INDRA_getTranslationKey('dates.text.' + (cur.format('MMMM')).toLowerCase()).substring(0, 3) + " " + cur.format('YY') }); });
        moment.locale(environment.locale);
        _this.bookAwardFlights$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.bookAwardFlights = value;
        });
        _this.datepickerOptions.dateFormat = _this.dateSerivce.INDRA_getDateFormat().toLowerCase();
        return _this;
    }
    INDRADatepickerModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.data && this.data[0] && this.data[0].params && this.data[0].params.datepickerOptions && this.data[0].params.datepickerOptions.disableSince.year !== 'Invalid date') {
            this.datepickerOptions = Object.assign(this.datepickerOptions, this.data[0].params.datepickerOptions);
            if (this.datepickerOptions.disableUntil) {
                if (this.datepickerOptions.disableUntil.day == parseFloat(moment().format('D')) - 1 && this.bookAwardFlights) {
                    // disable until current day if bookAwardFlight and datepicker is first row
                    this.datepickerOptions.disableUntil.day = parseFloat(moment().format('D'));
                }
                var departure = moment(this.datepickerOptions.disableUntil.day + "-" + this.datepickerOptions.disableUntil.month + "-" + this.datepickerOptions.disableUntil.year, 'D-M-YYYY');
                this.defMonth = departure.format('MM') + "-" + departure.format('YYYY');
            }
        }
        if (this.data && this.data[0] && this.data[0].params && this.data[0].params.value) {
            var value = moment(this.data[0].params.value, 'DD/MM/YYYY');
            this.myDateModel = { date: { year: parseFloat(value.format('YYYY')), month: parseFloat(value.format('M')), day: parseFloat(value.format('D')) } };
            this.defMonth = value.format('MM') + "-" + value.format('YYYY');
        }
        clearTimeout(this.openSelectorTimeout);
        this.openSelectorTimeout = setTimeout(function () { return _this.openSelector(); }, 100);
    };
    INDRADatepickerModalComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRADatepickerModalComponent.prototype.openSelector = function () {
        this.TAP_handleMoveMonth(this.TAP_findIndexMonth(), 'auto');
        this.datepickerSelector = {
            open: true
        };
    };
    INDRADatepickerModalComponent.prototype.closeSelector = function () {
        this.datepickerSelector = {
            open: false
        };
    };
    INDRADatepickerModalComponent.prototype.onDateChanged = function (event) {
        if (this.data && this.data[0] && this.data[0].handleClose) {
            this.data[0].handleClose(event);
        }
        this.closeModal();
    };
    INDRADatepickerModalComponent.prototype.calendarToggle = function (event) {
        return;
    };
    INDRADatepickerModalComponent.prototype.calendarViewChanged = function (event) {
        if (moment(event.month, 'M').format('MM') + "-" + event.year != this.defMonth) {
            // this.TAP_changeMonth(`${moment(event.month, 'M').format('MM')}-${event.year}`);
            var index = this.optionsMonth.findIndex(function (cur) { return cur.value == moment(event.month, 'M').format('MM') + "-" + event.year; });
            this.TAP_handleMoveMonth(index);
        }
    };
    INDRADatepickerModalComponent.prototype.TAP_changeMonth = function (defMonth) {
        var _this = this;
        this.myDateModel = null;
        if (this.data && this.data[0] && this.data[0].params && this.data[0].params.value) {
            var value = moment(this.data[0].params.value, 'DD/MM/YYYY');
            if (defMonth == value.format('MM') + "-" + value.format('YYYY')) {
                this.myDateModel = { date: { year: parseFloat(value.format('YYYY')), month: parseFloat(value.format('M')), day: parseFloat(value.format('D')) } };
            }
        }
        clearTimeout(this.defMonthTimeout);
        this.defMonthTimeout = setTimeout(function () {
            _this.defMonth = defMonth;
        }, 1);
    };
    INDRADatepickerModalComponent.prototype.TAP_handleMoveMonth = function (index, behavior) {
        if (index === void 0) { index = 0; }
        if (behavior === void 0) { behavior = 'smooth'; }
        var el = this.monthScroll.nativeElement;
        if (index != -1) {
            var defMonth = this.optionsMonth[index].value;
            this.TAP_changeMonth(defMonth);
            this.defMonthIndex = index;
            // const scrollLeft = index * el.offsetWidth;
            // el.scrollTo({ left: scrollLeft, top: 0, behavior });
        }
    };
    INDRADatepickerModalComponent.prototype.TAP_findIndexMonth = function () {
        var _this = this;
        return this.optionsMonth.findIndex(function (cur) { return cur.value == _this.defMonth; });
    };
    INDRADatepickerModalComponent.prototype.TAP_handleMoveBack = function () {
        var _this = this;
        var index = this.optionsMonth.findIndex(function (cur) { return cur.value == _this.defMonth; });
        if (index > 0) {
            --index;
        }
        else {
            index = 0;
        }
        this.TAP_handleMoveMonth(index);
    };
    INDRADatepickerModalComponent.prototype.TAP_handleMoveForward = function () {
        var _this = this;
        var index = this.optionsMonth.findIndex(function (cur) { return cur.value == _this.defMonth; });
        if (index >= (this.optionsMonth.length - 1)) {
            index = this.optionsMonth.length - 1;
        }
        else {
            ++index;
        }
        this.TAP_handleMoveMonth(index);
    };
    INDRADatepickerModalComponent.prototype.INDRA_getTranslationKey = function (key, isDays) {
        if (isDays) {
            return this.ibeAdminService.getTranslationValue(key).substring(0, 1).toUpperCase();
        }
        else {
            return this.ibeAdminService.getTranslationValue(key);
        }
    };
    INDRADatepickerModalComponent.prototype.INDRA_getDays = function () {
        var isDays = true;
        var days = {
            su: this.INDRA_getTranslationKey('dates.text.sunday', isDays),
            mo: this.INDRA_getTranslationKey('dates.text.monday', isDays),
            tu: this.INDRA_getTranslationKey('dates.text.tuesday', isDays),
            we: this.INDRA_getTranslationKey('dates.text.wednesday', isDays),
            th: this.INDRA_getTranslationKey('dates.text.thursday', isDays),
            fr: this.INDRA_getTranslationKey('dates.text.friday', isDays),
            sa: this.INDRA_getTranslationKey('dates.text.saturday', isDays)
        };
        return days;
    };
    return INDRADatepickerModalComponent;
}(AbstractModalContentComponent));
export { INDRADatepickerModalComponent };
